import React from "react";
import IconBase, { IconBaseProps } from "./IconBase";

const IconHealthCheckup: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 18 22"
      {...props}
    >
      <path
        d="M11.6387 0C12.4646 0 13.1374 0.659745 13.1377 1.47461V2.3584H16.7422C17.0162 2.35854 17.2393 2.57921 17.2393 2.84961V21.5059C17.2393 21.7763 17.0199 21.9999 16.7422 22H1.26172C0.98758 22 0.760742 21.7763 0.760742 21.5059V2.84961C0.760742 2.57912 0.98758 2.35548 1.26172 2.35547H4.86621V1.47461C4.86647 0.663438 5.53845 0.00014584 6.36426 0H11.6387ZM1.7627 21.0117H16.2451V3.34375H13.1416V3.8125C13.1414 4.62741 12.4686 5.29102 11.6426 5.29102H6.36816C5.5422 5.291 4.86934 4.63101 4.86914 3.8125V3.34375H1.7627V21.0117ZM12.6777 17.2217C12.9519 17.2217 13.1787 17.4417 13.1787 17.7158C13.1785 17.9897 12.9517 18.21 12.6777 18.21H5.31934C5.04548 18.2098 4.82248 17.9896 4.82227 17.7158C4.82227 17.4454 5.04534 17.2219 5.31934 17.2217H12.6777ZM11.4492 14.5557C11.7232 14.5557 11.9461 14.7759 11.9463 15.0498C11.9463 15.3203 11.7233 15.5439 11.4492 15.5439H6.56543C6.28771 15.5438 6.06445 15.3202 6.06445 15.0498C6.06462 14.7759 6.29147 14.5558 6.56543 14.5557H11.4492ZM9.00391 7.73633C9.27804 7.73634 9.50098 7.95998 9.50098 8.23047V9.53223H10.8203C11.0981 9.53223 11.3213 9.75227 11.3213 10.0264C11.3212 10.2968 11.0981 10.5166 10.8203 10.5166H9.50098V11.8184C9.50098 12.0888 9.27804 12.3125 9.00391 12.3125C8.7261 12.3125 8.50293 12.0889 8.50293 11.8184V10.5166H7.18359C6.90949 10.5166 6.68269 10.3004 6.68262 10.0264C6.68262 9.75227 6.90945 9.53223 7.18359 9.53223H8.50293V8.23047C8.50293 7.95998 8.7261 7.73633 9.00391 7.73633ZM5.86328 3.8125C5.86348 4.08634 6.08671 4.3065 6.36426 4.30664H11.6387C11.9127 4.30664 12.1365 4.08643 12.1367 3.8125V3.34375H5.86328V3.8125ZM6.36426 0.984375C6.08674 0.984519 5.86354 1.20442 5.86328 1.47461V2.35547H12.1367V1.47461C12.1365 1.20433 11.9127 0.984375 11.6387 0.984375H6.36426Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
    </IconBase>
  );
};

export default IconHealthCheckup;
